"use client";

import Link from "next/link";

/* Quando una pagina resa dal server non riesce a parlare con l'API (database
   spento, API in riavvio) Next mostrava la sua pagina d'errore: in sviluppo il
   riquadro rosso tecnico, in produzione una riga in inglese senza via d'uscita.
   Qui si dice cosa e' successo, si offre di riprovare e si lasciano le pagine
   che non dipendono dal catalogo. Lo stile e' lo stesso di not-found.tsx. */

export default function Errore({ retry }: { error: Error & { digest?: string }; retry: () => void }) {
  return (
    <div className="mx-auto max-w-2xl px-6 py-20">
      <h1 className="text-2xl font-semibold tracking-tight">Il catalogo non risponde</h1>
      <p className="mt-2 text-muted">
        Questa pagina ha bisogno del catalogo, che in questo momento non è raggiungibile.
        Di solito si risolve in pochi minuti: riprova fra poco.
      </p>

      <div className="mt-8 flex flex-wrap gap-3">
        <button
          type="button"
          onClick={() => retry()}
          className="rounded-lg bg-accent px-4 py-2.5 font-medium text-accent-contrast transition hover:opacity-90"
        >
          Riprova
        </button>
        <Link
          href="/"
          className="rounded-lg border border-line px-4 py-2.5 font-medium transition hover:border-accent"
        >
          Torna all&apos;inizio
        </Link>
      </div>

      <p className="mt-10 text-sm text-muted">
        Se il problema resta,{" "}
        <Link href="/contatti" className="text-accent underline underline-offset-2">
          scrivici
        </Link>{" "}
        e lo sistemiamo.
      </p>
    </div>
  );
}
